module.exports = __webpack_public_path__ + "static/media/comment.dee1c974.svg";